import {
  PersistedFormGroup,
  PersistedFormArray,
  PersistedArray,
} from './persisted-form-group';
import type {
  PersistedFormGroupOptions,
  PersistedFormArrayOptions,
  PersistedArrayOptions,
} from './persisted-form-group';
import type { SchemaFormControl } from '@apexdesigner/schema-forms';
import { ProcessService } from './process-service';
export { ProcessService };
import { processServiceSchema } from '@schemas/business-objects/process-service';
import { ProcessServicePropertyFormArray } from './process-service-property-form-group';

export class ProcessServiceFormGroup extends PersistedFormGroup {
  declare controls: {
    id: SchemaFormControl;
    name: SchemaFormControl;
    displayName: SchemaFormControl;
    description: SchemaFormControl;
    properties: ProcessServicePropertyFormArray;
  };

  declare value: Partial<ProcessService>;

  constructor(
    data?: Record<string, any> | null,
    options?: PersistedFormGroupOptions,
  ) {
    super(processServiceSchema, ProcessService, data, options);
  }

  get object(): ProcessService {
    return new ProcessService(this.getRawValue());
  }

  protected override createControl(name: string) {
    switch (name) {
      case 'properties':
        return new ProcessServicePropertyFormArray();
      default:
        return undefined;
    }
  }

  static async find(filter?: any): Promise<ProcessService[]> {
    return ProcessService.find(filter);
  }

  static async findOne(filter?: any): Promise<ProcessService | null> {
    return ProcessService.findOne(filter);
  }

  static async findById(id: string, filter?: any): Promise<ProcessService> {
    return ProcessService.findById(id, filter);
  }

  static async create(data: Partial<ProcessService>): Promise<ProcessService> {
    return ProcessService.create(data as any);
  }

  static async updateById(
    id: string,
    updates: Partial<ProcessService>,
  ): Promise<ProcessService> {
    return ProcessService.updateById(id, updates as any);
  }

  static async deleteById(id: string): Promise<boolean> {
    return ProcessService.deleteById(id);
  }
}

export class ProcessServiceFormArray extends PersistedFormArray {
  declare controls: ProcessServiceFormGroup[];

  readonly entityName = 'ProcessService' as const;

  constructor(options?: PersistedFormArrayOptions) {
    super(processServiceSchema, ProcessService, options);
  }

  protected override createItemGroup() {
    return new ProcessServiceFormGroup();
  }

  get array(): ProcessService[] {
    return this.controls.map((group: ProcessServiceFormGroup) => group.object);
  }
}

export class ProcessServicePersistedArray extends PersistedArray<ProcessService> {
  readonly entityName = 'ProcessService' as const;

  constructor(options?: PersistedArrayOptions) {
    super(ProcessService, options);
  }
}
